var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFashionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-fashion_icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 248
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fashion_icon",
    clipPath: "url(#clip-fashion_icon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_215",
    "data-name": "\\uD328\\uC2A4 215",
    d: "M805.942,261.138a124,124,0,0,0-124,124,124,124,0,0,0-124-124,124,124,0,0,0,124-124A124,124,0,0,0,805.942,261.138Z",
    transform: "translate(-557.942 -137.138)",
    fill: "#db3633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_216",
    "data-name": "\\uD328\\uC2A4 216",
    d: "M739.946,337.965l13.936,7.736L735.3,366.367l24.388,6.968,22.066,6.968L735.3,386.178s13.936,18.286,17.42,14.916c2.506-2.425,24.839-.39,37.18.4,4.817.308,8.112.426,8.112.016,0-1.463-23.227,10.15-23.227,10.15H710.433",
    transform: "translate(-603.191 -196.366)",
    fill: "none",
    stroke: "#161619",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_389",
    "data-name": "\\uADF8\\uB8F9 389",
    transform: "translate(68.364 89.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_4",
    "data-name": "\\uD0C0\\uC6D0 4",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#161619",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.737,
    cy: 26.737,
    rx: 26.737,
    ry: 26.737,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.737,
    cy: 26.737,
    rx: 25.737,
    ry: 25.737,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_25",
    "data-name": "\\uC120 25",
    x1: 37.812,
    y2: 37.812,
    transform: "translate(7.831 7.831)",
    fill: "#fff",
    stroke: "#161619",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "fashion_icon-2",
    "data-name": "fashion_icon",
    transform: "translate(-26 -26)",
    fill: "#707070",
    fontSize: 20,
    fontFamily: "AppleSDGothicNeo-Regular, Apple SD Gothic Neo"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "fashion_icon")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFashionIcon);
export default __webpack_public_path__ + "static/media/fashion_icon.4cc7938dc838256b6116fd7dac372bd4.svg";
export { ForwardRef as ReactComponent };